import PathwayProjectCard from 'components/shared/PathwayProjectCard/PathwayProjectCard'
import PropTypes from 'prop-types'
import React from 'react'
import { withNamespaces } from 'react-i18next'
import classNames from 'classnames'
import PathwayLabel from './PathwayLabel/PathwayLabel'
import './Projects.scss'

const strNotEmpty = (val) =>
  !(typeof val === 'undefined' || val === null || val === '')

export const Projects = ({ locale, projects = {}, steps = [], ordered }) => {
  let previousCategory
  return (
    <div className={'sc-pr-pathway-projects-container'}>
      <div
        className={classNames('sc-pr-pathway-projects-wrapper', {
          'sc-pr-pathway-projects-wrapper--ordered': !!ordered,
        })}
      >
        {Object.entries(projects).map(([i, project]) => {
          const badgeAvailable = strNotEmpty(project.content?.badgeTemplateId)
          let state, category, badgeImage

          if (project?.userProgress) {
            if (
              badgeAvailable &&
              (project.userProgress?.completed_external_at ||
                project?.issuedBadge)
            ) {
              state = 'complete'
            } else if (
              !badgeAvailable &&
              project.userProgress?.completed_internal_at
            ) {
              state = 'complete'
            } else {
              state = 'inProgress'
            }
          }
          if (project?.issuedBadge) {
            badgeImage = project.issuedBadge?.badge_template?.image
          }
          if (
            steps.length === Object.keys(projects).length &&
            steps[i]?.category
          ) {
            category =
              steps[i]?.category === previousCategory
                ? null
                : steps[i]?.category
            previousCategory = steps[i]?.category
          }
          return (
            <div key={i}>
              {category && ordered && (
                <PathwayLabel
                  className={'sc-pr-pathway-projects__label'}
                  key={`${category}-${i}`}
                  category={category}
                  locale={locale}
                />
              )}
              <PathwayProjectCard
                className={'sc-pr-pathway-projects__project-card'}
                key={`project-${i}`}
                locale={locale}
                project={project}
                state={state}
                badgeImage={badgeImage}
                badgeAvailable={badgeAvailable}
                ordered={ordered}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}

Projects.propTypes = {
  locale: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  projects: PropTypes.object.isRequired,
  steps: PropTypes.array,
  ordered: PropTypes.bool.isRequired,
}

export default withNamespaces('translations')(Projects)
